module.exports = __webpack_public_path__ + "static/media/Lauren_chil.2debd633.svg";